import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Table, Pagination, Popconfirm, Space, Row, Col, Modal, message, Upload } from 'antd';
import { DeleteOutlined, FormOutlined, RedoOutlined, SearchOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import _axios from '../unit/axios';

function Cate1() {

    
    const [user, setUser] = useState([]);
    const [auth, setAuth] = useState([]);
    let isinit = false;
    useEffect(() => {
        if (!isinit) {
            var user = JSON.parse(localStorage.getItem('user'));
            setUser(user);
            if (user.id != '3') { 
                setAuth(JSON.parse(localStorage.getItem('auth') || '[]'));
            }
            getList();
            isinit = true;
        }

    }, [])

    const [loading, setLoading] = useState(false);
    const seachource = useRef({});
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [searchForm] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const getList = async () => {
        var p = {
            page,
            size,
            ...seachource.current,
        }
        setLoading(true);
        _axios.get('/api.v1/question/cate/1th/list', { params: p }).then(res => {
            setList(res.data.list || []);
            setTotal(res.data.total || 0);
            setLoading(false);
        }).catch(err => {
            console.log(err)
            setLoading(false);
        })
    }

    useEffect(() => {
        getList();
    }, [page, size])

    const onFinish = (values) => {
        console.log('Success:', values);
        for (const key in values) {
            if (values[key] === null || values[key] === undefined) {
                delete values[key];
            }
        }
        seachource.current = values;
        page == 1 ? getList() : setPage(1);
    };

    const columns = [{
        title: '名称',
        dataIndex: 'name',
        key: 'name',
        width: '180px',
    }, {
        title: '描述',
        dataIndex: 'description',
        key: 'description',
    }, {
        title: '操作',
        key: 'action',
        width: '180px',
        align: 'center',
        render: (_, record) => {
            return <Space size="middle">
                {(user.id == '3' || auth.includes('cate1-edit')) && <Button color="primary" variant="solid" size="small" onClick={() => showModal('edit', record)}><FormOutlined />修改</Button>}
                {(user.id == '3' || auth.includes('cate1-del')) && <Popconfirm title="系统提示" description="确定删除该数据吗？" okText="确定" cancelText="取消" onConfirm={() => deleteRow(record)}>
                    <Button color="danger" variant="solid" size="small" disabled={loading}><DeleteOutlined />删除</Button>
                </Popconfirm>}
            </Space>
        },
    }]

    const [form] = Form.useForm();
    const [modalShow, setModalShow] = useState(false);
    const [modalData, setModalData] = useState({});
    const [iconList, setIconList] = useState([]);
    const [videoList, setVideoList] = useState([]);
    const showModal = (type = 'add', row) => {
        var data = { name: '', description: '', type };
        if (row) {
            data = Object.assign(data, row);
            setIconList(data.icon ? [{ name: data.name, url: data.icon }] : []);
            setVideoList(data.video ? [{ name: data.name, url: data.video }] : []);
        } else {
            setIconList([]);
            setVideoList([]);
        }
        form.setFieldsValue(data);
        setModalData(data);
        setModalShow(true);
    }

    const deleteRow = (row) => {
        setLoading(true);
        _axios.delete('/api.v1/question/cate/1th', { data: { id: row.id } }).then(res => {
            messageApi.open({
                type: 'success',
                content: '删除成功',
            })
            setDelModalShow(false);
            setLoading(false);
            page == 1 ? getList() : setPage(1);
        }).catch(err => {
            messageApi.open({
                type: 'error',
                content: '删除失败',
            })
            setLoading(false);
        })
    }

    const save = () => {
        form.submit();
    }

    const submit = (values) => {
        setLoading(true);
        var p = Object.assign(modalData, values);
        p.icon = iconList.length ? iconList[0].url : '';
        p.vide = videoList.length ? videoList[0].url : '';
        _axios.put('/api.v1/question/cate/1th', p).then(res => {
            messageApi.open({
                type: 'success',
                content: '提交成功',
            })
            setModalShow(false);
            setLoading(false);
            page == 1 ? getList() : setPage(1);
        }).catch(err => {
            messageApi.open({
                type: 'error',
                content: '提交失败',
            })
            setLoading(false);
        })
    }

    function uploadInit(props, type) {
        const { onSuccess, onError, file, onProgress } = props;
        const formData = new FormData();
        formData.append('file', file);
        // 使用你喜欢的HTTP库发送请求
        _axios.post('/api.v1/upload/file', { file }).then((res) => {
            if (res.code == 0) {
                onSuccess();
                setModalData({ ...modalData, cover: JSON.stringify({ name: file.name, url: res.data.path }) });
                if (type == 'icon') {
                    setIconList([{ name: file.name, url: res.data.path }]);
                } else if (type == 'video') {
                    setVideoList([{ name: file.name, url: res.data.path }]);
                }
            } else {
                messageApi.open({
                    type: 'error',
                    content: res.message,
                })
                onError();
            }
        }).catch((err) => {
            console.log(err)
            onError();
        });
    }

    const uploadChange = ({ fileList: newFileList }, type) => {
        if (type == 'icon') {
            setIconList(newFileList);
        } else if (type == 'video') {
            setVideoList(newFileList);
        }
    };

    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>上传</div>
        </button>
    );


    return (
        <div style={{ padding: '20px', flex: '1',  }}>
            <Form form={searchForm} onFinish={onFinish} autoComplete="off" layout="inline" style={{ borderBottom: '1px solid #ccc', marginBottom: '20px', display: 'block' }}>
                <Row>
                    <Col span={6} style={{ marginBottom: '20px' }}>
                        <Form.Item label="名称" name="name">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6} style={{ marginBottom: '20px' }}>
                        <Form.Item>
                            <Button onClick={() => { searchForm.resetFields(); }} style={{ marginRight: '12px' }}>
                                <RedoOutlined />重置
                            </Button>
                            <Button color="primary" variant="solid" htmlType="submit" disabled={loading} style={{ marginRight: '12px' }}>
                                <SearchOutlined />查询
                            </Button>
                            {(user.id == '3' || auth.includes('cate1-add')) && <Button color="primary" variant="filled" onClick={() => showModal()}>
                                <PlusOutlined />新增
                            </Button>}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <Table dataSource={list} columns={columns} pagination={false} rowKey="id"></Table>

            <div style={{ marginTop: '20px' }}>
                <Pagination current={page} pageSize={size} total={total} align='end'
                    onChange={(page, size) => {
                        setPage(page);
                        setSize(size);
                    }}
                />
            </div>

            <Modal title={modalData.type == 'add' ? '新增' : '修改'} open={modalShow} onOk={save} onCancel={() => setModalShow(false)} okText="提交" cancelText="取消" width={780}>
                <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} onFinish={submit} autoComplete="off" disabled={loading}>
                    <Form.Item label="名称" name="name" rules={[{ required: true, message: '名称不能为空' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="描述" name="description">
                        <Input.TextArea autoSize />
                    </Form.Item>
                    <Form.Item label="图标" name="icon">
                        <Upload customRequest={(props) => uploadInit(props, 'icon')} listType="picture-card" fileList={iconList} onChange={(props) => uploadChange(props, 'icon')}>
                            {iconList.length > 0 ? null : uploadButton}
                        </Upload>
                    </Form.Item>
                    <Form.Item label="视频" name="video">
                        <Upload customRequest={(props) => uploadInit(props, 'video')} fileList={videoList} onChange={(props) => uploadChange(props, 'video')}>
                            <Button icon={<UploadOutlined />}>上传</Button>
                        </Upload>
                    </Form.Item>
                    
                </Form>
            </Modal>

            {contextHolder}
        </div>

    )
}
export default Cate1;